import { LitElement } from 'lit';
import Packery from './lib/Packery';

class ToujouGallery extends LitElement {
  static get is() {
    return 'toujou-gallery';
  }

  createRenderRoot() {
    return this;
  }

  connectedCallback() {
    super.connectedCallback();

    this.intersectionObserver = new IntersectionObserver((entries) => {
      if (entries.some((entry) => entry.isIntersecting)) {
        const packery = new Packery(this, {
          columnWidth: '.gallery__grid-sizer',
          rowHeight: '.gallery__grid-sizer',
          itemSelector: '.gallery__item',
          transitionDuration: '0s',
          isInitLayout: false,
        });

        packery.layout();

        this.intersectionObserver.disconnect();
      }
    });
    this.intersectionObserver.observe(this);
  }

  disconnectedCallback() {
    this.intersectionObserver && this.intersectionObserver.disconnect();
    super.disconnectedCallback();
  }
}

customElements.define(ToujouGallery.is, ToujouGallery);
